<template>
  <div justify="center">
    <v-dialog v-model="officerDialog" persistent class="main-dialog" :max-width="mainDialogWidth">
      <v-card justify="center">
        <!-- ダイアログタイトル -->
        <v-card-title class="subtitle-1 light-green lighten-3"> 変更する役員様の資格(役員役職)・氏名・事由等を入力してください。</v-card-title>

        <v-card-text>
          <v-row dense>
            <v-col cols="12" class="pt-6">
              <span class="text-caption text-sm-h6"><v-icon color="green darken-4">mdi-lead-pencil</v-icon>をクリックし入力をはじめてください。</span>
             </v-col>
          </v-row> 
          <v-row dense class="mb-1">
            <v-col cols="12" class="pa-0"> 
              <!-- 注意喚起文-->      
              <span class="text-caption text-sm-h6 red-moji">※10人以上の登録は別途ご連絡下さい。</span>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col cols="12">
              <v-sheet min-height="1vh" color="transparent"></v-sheet>
            </v-col>
          </v-row> -->

          <!-- 役員情報入力一覧 -->
          <v-data-table
            :headers="headers"
            :items="desserts"
            item-key="no" 
            :single-expand="detaiInfoSingleExpand"
            :expanded.sync="expanded"
            show-expand 
            hide-default-footer
            :disable-sort="true"
            class="v-dtbl-md-1 v-dtbl-head-md-1 v-dtbl-body-md-1 elevation-1"
            style="width: 100%"
            :key="isMobile ? expanded.length : ''"
            calculate-widths
          >
            <template v-slot:[`item.officer`]="{ item }">
              {{ item.officer.name }}
            </template>
            <!-- 登記の事由 -->
            <!-- <template v-slot:[`item.reason.name`]="{ item }">
              {{ getReasonName(item.reason.cd) }}
            </template> -->
            <template v-slot:[`item.reason`]="{ item }">
              {{ item.reason.name }}
            </template>
            <!-- "原因年月日 -->
            <!-- <template v-slot:[`item.genindate`]="{ item }">
              {{ frmtDate(item.genindate) }}
            </template> -->
            <!-- 操作列 -->
            <template v-slot:[`item.input`]="{ item }">
              <v-icon  color="green darken-4" large  @click="editItem(item)">mdi-lead-pencil</v-icon>
            </template>
            <template v-slot:[`item.delete`]="{ item }">
              <v-icon large @click="deleteItem(item)">mdi-delete-circle-outline</v-icon>
            </template>
            <!-- 役員詳細 -->
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <div class="expand-box">
                  <span class="box-title">役員住所</span>
                  <p v-html="item.address" style="font-size: 0.9em"></p>
                </div>  
              </td>
            </template>
            
            <template v-slot:top>
              <v-toolbar color="white" min-height="80">
                <v-row class="pt-10 mt-0">
                  <v-col cols="2" sm=1 class="pl-0">
                    <label class="required d-flex justify-end align-end"></label>
                  </v-col>
                  <v-col cols="8" sm=4 class="pl-0">
                    <v-menu v-model="menuInputDateFlg" :close-on-content-click="false" :nudge-right="40" min-width="auto" transition="scale-transition" offset-y >
                      <template v-slot:activator="{ on, attrs }" >
                        <v-text-field
                          v-model="inputDate"
                          :label="inputDateLabelName"
                          persistent-hint
                          prepend-icon="mdi-calendar"
                          readonly
                          clearable
                          v-bind="attrs"
                          v-on="on"
                          class="text-subtitle-1 text-sm-h6"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="inputDate" @input="menuInputDateFlg = false" locale="ja"></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="2" sm=7 class="d-flex align-center justify-end">
                    <v-btn small color="primary" fab dark @click="clear()">
                      <v-icon>mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>

                  <!-- <v-btn color="primary" fab dark @click="clear()">
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </v-btn> -->
                <!-- <v-row>  
                  <v-col cols="11" class="px-0">
                    <v-row dense>
                      <v-col cols="12" class="pa-0">
                          <span class="text-caption text-sm-subtitle-1"><v-icon color="green darken-4">mdi-playlist-edit</v-icon>をクリックし入力をはじめてください。</span>
                      </v-col>
                    </v-row>       
                    <v-row dense>
                      <v-col cols="12" class="pa-0">   
                          <span class="text-caption red-moji">※10人以上の登録は別途ご連絡下さい。</span>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="1" class="d-flex justify-end align-end pa-0">
                    <v-btn small color="primary" fab dark @click="clear()">
                      <v-icon>mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </v-col>
                </v-row> -->

                <!-- 役員情報入力ダイアログ -->
                <v-dialog v-model="inputDialog" :max-width="inputDialogWidth">
                  <v-card>
                    <!-- <v-card-text> -->
                      <v-container>
                        <!-- 資格 -->
                        <v-row>
                          <v-col cols="2">
                            <label class="required d-flex justify-end align-end"></label>
                          </v-col>
                          <v-col cols="10" class="pt-0">
                           <!-- <v-text-field v-model="editedItem.officerNm" label="資格(役員役職)"></v-text-field> -->
                            <v-select
                              v-model="editedItem.officer"
                             :items="officers"
                             :menu-props="{ top: true, offsetY: true }"
                             item-text="name"
                             item-value="cd"
                             label="資格(役員役職)"
                             :disabled="disabledOfficers"
                             return-object
                            ></v-select>
                         </v-col>
                       </v-row>
                       <!-- 氏名 -->
                        <v-row>
                          <v-col cols="2">
                            <label class="required d-flex justify-end align-end"></label>
                          </v-col>
                         <v-col cols="10" class="pt-0">
                           <v-text-field v-model="editedItem.name" label="氏名"></v-text-field>
                         </v-col>
                        </v-row>
                        <!-- 氏名（フリガナ） -->
                        <!-- <v-row>
                          <v-col cols="2">
                            <label class="required d-flex justify-end align-end"></label>
                          </v-col>
                         <v-col cols="10" class="pt-0">
                           <v-text-field v-model="editedItem.nameKana" label="氏名(フリガナ)"></v-text-field>
                         </v-col>
                        </v-row> -->
                        <!-- 登記の事由 -->
                       <v-row>
                          <v-col cols="2">
                            <label class="required d-flex justify-end align-end"></label>
                          </v-col>
                         <v-col cols="10" class="pt-0">
                            <v-select
                              v-model="editedItem.reason"
                             :items="reasons"
                             :menu-props="{ top: true, offsetY: true }"
                             item-text="name"
                             item-value="cd"
                             label="変更の事由"
                             :disabled="disabledReasons"
                             return-object
                            ></v-select>
                            <!-- @change="changeReason(editedItem.reason.cd)" -->
                          </v-col>
                       </v-row>
                        <!-- 役員変更詳細 -->
                        <!-- <v-row>
                          <v-col cols="2">
                            <label class="required d-flex justify-end align-end"></label> -->
                            <!-- <template v-if="requiredDetailInfo">
                              <label class="required d-flex justify-end align-end"></label>
                            </template>
                            <template v-else>
                            </template> -->
                          <!-- </v-col>
                          <v-col cols="10" class="pt-0">
                            <v-textarea label="変更詳細" outlined id="textarea" v-model="editedItem.detailInfo" rows="8" overflow="scroll" single-line dense solo></v-textarea>
                          </v-col>
                        </v-row> -->
                        <!-- 役員住所 -->
                        <v-row>
                          <v-col cols="2">
                            <label class="required d-flex justify-end align-end"></label>
                          </v-col>
                         <v-col cols="10" class="pt-0">
                           <v-text-field v-model="editedItem.address" label="役員住所"></v-text-field>
                         </v-col>
                        </v-row>
                      </v-container>
                   <!-- </v-card-text> -->
                    <!-- <v-divider class="mx-4"></v-divider> -->
                   <!-- 役員情報入力ダイアログボタン -->
                   <v-card-actions>
                     
                     <v-row class="mb-6">
                     <v-col cols="6" class="d-flex align-center justify-center py-0">
                        <v-btn color="warning" dark min-width="100px" @click="saveDialog">確定</v-btn>
                     </v-col>
                      <v-col cols="6" class="d-flex align-center justify-center py-0">
                        <v-btn color="warning" dark min-width="100px" @click="closeDialog">キャンセル</v-btn>
                      </v-col>
                     </v-row>
                   </v-card-actions>
                   
                  </v-card>
                </v-dialog>
                <!-- 役員情報入力ダイアログ end -->
              </v-toolbar>
            </template>
          </v-data-table>
          <!-- 役員情報入力一覧 end -->

          <!-- ボタンエリア -->
          <v-row class="mt-5">
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex align-center justify-center">
              <v-btn x-large color="warning" dark min-width="160px" @click="save()">確定</v-btn>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex align-center justify-center">
             <v-btn x-large color="warning" dark min-width="160px" @click="cancel()">キャンセル</v-btn>
            </v-col>
          </v-row>
        
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- その他 -->
    <comMessage :msg="dlgMsgInputErr.msg" :is-open="dlgMsgInputErr.isOpen" :do-yes="dlgMsgInputErr.doYes"></comMessage>
    <comMessageConfirm :msg="dlgMsgConfirm.msg" :isOpen="dlgMsgConfirm.isOpen" :doYes="dlgMsgConfirm.doYes" :doNo="dlgMsgConfirm.doNo" />
    <comMessageConfirm :msg="dlgMsgConfirmAllDel.msg" :isOpen="dlgMsgConfirmAllDel.isOpen" :doYes="dlgMsgConfirmAllDel.doYes" :doNo="dlgMsgConfirmAllDel.doNo" />
  </div>
</template>

<script>

import Constants from "../common/constants";
import Utils from "../common/utils";
export default {
  name: "InputOfficerInfo",
  props: ["isOpen", "doYes", "doNo", "propInputTyp"],
  data() {
    return {
      screenTitle: "役員情報",
      officerDialog: false,
      inputDialog: false,
      inputDateLabelName: "",
      menuInputDateFlg: "",
      inputDate: null,

      reasons: [],
      disabledReasons: false,
      officers: [],
      disabledOfficers: false,
      // requiredDetailInfo: false,
      // datePickerMenu: false,
      detaiInfoSingleExpand: true,
      editedIndex: -1,

      isMobile: false,
      expanded: [],

      headers: [
        { text: "No", align: "center", value: "no", width: "6%"  },
        { text: '入力', align: "start", value: 'input', sortable: false, width: "7%"  },
        { text: "資格(役員役職)", align: "start", value: "officer", width: "15%" },
        { text: "氏名", align: "start", value: "name", width: "20%" },
        // { text: "氏名(フリガナ)", align: "start", value: "nameKana", width: "20%" },
        // { text: "事由CD", align: ' d-none', value: "reason.cd", width: "5%" },
        { text: "登記の事由", align: "start", value: "reason", width: "15%" },
        // { text: "役員変更詳細", align: "center", value: "data-table-expand", width: "5%" },
        { text: "役員住所", align: "center", value: "data-table-expand", width: "5%" },
        
        { text: '削除', align: "center", value: 'delete', sortable: false, width: "7%"  }, 
      ],
      desserts: [],
      defaultDesserts: [],
      // editedItem: { officerNm: "", name: "", nameKana: "", reason:{ cd:"", name:"" }, detailInfo: ""},
      // defaultItem: { officerNm: "", name: "", nameKana: "", reason:{ cd:"", name:"" }, detailInfo: ""},
      // deletedItem: {no: "", officerNm: "", name: "", nameKana: "", reason:{ id:"", name:"" }, detailInfo: ""},
      editedItem: { officer: { cd:"", name:"" }, name: "", reason:{ cd:"", name:"" }, detailInfo: "", address:""},
      defaultItem: { officer: { cd:"", name:"" }, name: "", reason:{ cd:"", name:"" }, detailInfo: "", address:""},
      deletedItem: {no: "", officer: { cd:"", name:"" }, name: "", reason:{ cd:"", name:"" }, detailInfo: "", address:""},
      dlgMsgConfirm: {
        msg: this.$i18n.t('msg.wrn.cm011'),
        isOpen: false,
        doYes: () => {
          let index = this.desserts.indexOf(this.deletedItem);
          Object.assign(this.desserts[index], this.defaultItem);
          this.dlgMsgConfirm.isOpen = false;
        },
        doNo: () => {
          this.dlgMsgConfirm.isOpen = false;
        },
      },
      dlgMsgConfirmAllDel: {
        msg: this.$i18n.t('msg.wrn.cm010'),
        isOpen: false,
        doYes: () => {
          this.clearInputDataTable();
          // this.$store.dispatch("requestRegInfo/setOfficerList", []);
          // this.defaultDesserts = JSON.parse(JSON.stringify(this.desserts));
          this.dlgMsgConfirmAllDel.isOpen = false;
        },
        doNo: () => {
          this.dlgMsgConfirmAllDel.isOpen = false;
        },
      },
      dlgMsgInputErr: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsgInputErr.isOpen = false;
        },
      },
    };
  },
  computed: {
    mainDialogWidth() {
      let bp =this.$vuetify.breakpoint.name;
      if (bp == 'xs' || bp == 'sm') {
        return "100%";
      } else {
        return "70%";
      }
    },
    inputDialogWidth() {
      let bp =this.$vuetify.breakpoint.name;
      if (bp == 'xs' ) {
        return "100%";
      } else if (bp == 'md' || bp == 'sm') {
        return "80%";
      } else if (bp == 'lg') {
        return "60%";
      } else {
        return "40%";
      }
    }
  },
  watch: {
    isOpen: function (val) {
      this.officerDialog = val;
      if (val) {
        this.initialize();
      }
    },
  },
  beforeDestroy () {
    if (typeof window === 'undefined') return
    window.removeEventListener('resize', this.onResize, { passive: true })
  },
  mounted () {
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
  },
  created() {
      // this.initialize();
  },
  methods: {

    onResize () {
      // this.isMobile = window.innerWidth < 450
      let bp =this.$vuetify.breakpoint.name;
      if (bp == 'xs' ) {
        this.isMobile = true;
      }
    },

    /*
    * 画面初期表示処理
    */
    initialize() {
      // // 役員変更区分マスタ取得
      // this.reasons = this.$store.getters['master/getChangeOfficerKbnList'];
      // 資格区分マスタ取得
      this.officers = this.$store.getters['master/getOfficerKbnList'];
      // 入力種別毎の設定
      if (this.propInputTyp === Constants.INPUT_TYP_APPOINT) {
        // 就任系
        this.inputDateLabelName = "株主総会・取締役会の開催日付";
        this.inputDate = this.$store.getters['requestRegInfo/getAppointDate'];
      } else if (this.propInputTyp === Constants.INPUT_TYP_RESIGN) {
        // 退任系
        this.inputDateLabelName = "退任等の日付";
        this.inputDate = this.$store.getters['requestRegInfo/getResignDate'];
      } else if (this.propInputTyp === Constants.INPUT_TYP_ADDRESS) {
        // 住所変更
        this.inputDateLabelName = "住所移転日付";
        this.inputDate = this.$store.getters['requestRegInfo/getOthersDate'];
      }
      // 役員情報入力データテーブル生成
      this.createInputDataTable();
      this.defaultDesserts = JSON.parse(JSON.stringify(this.desserts));

      // ストアデータ初期化
      let emptyArray = [];
      if (this.propInputTyp === Constants.INPUT_TYP_APPOINT || this.propInputTyp === Constants.INPUT_TYP_RESIGN) {
        this.$store.dispatch('requestRegInfo/setOfficerOthersList', emptyArray);
        this.$store.dispatch('requestRegInfo/setOthersDate', "");
      } else {
        this.$store.dispatch('requestRegInfo/setOfficerAppointList', emptyArray);
        this.$store.dispatch('requestRegInfo/setOfficerResignList', emptyArray);
        this.$store.dispatch('requestRegInfo/setAppointDate', "");
        this.$store.dispatch('requestRegInfo/setResignDate', "");
      }

    },
    /**
     * 役員情報入力データテーブル生成
     */
    createInputDataTable() {
      let saveDataArry = null;
      // let saveDataArry = this.$store.getters['requestRegInfo/getOfficerList'];
      if (this.propInputTyp === Constants.INPUT_TYP_APPOINT) {
        // 就任系
        saveDataArry = this.$store.getters['requestRegInfo/getOfficerAppointList'];
      } else if (this.propInputTyp === Constants.INPUT_TYP_RESIGN) {
        // 退任系
        saveDataArry = this.$store.getters['requestRegInfo/getOfficerResignList'];
      } else if (this.propInputTyp === Constants.INPUT_TYP_ADDRESS) {
        // 住所変更
        saveDataArry = this.$store.getters['requestRegInfo/getOfficerOthersList'];
      }
      if (saveDataArry.length == 10) {
        this.desserts = JSON.parse(JSON.stringify(saveDataArry));
        return;
      }
      // if (saveDataArry == null || saveDataArry.length == 0 || saveDataArry[0].nameKana == "") {
      //   this.clearInputDataTable();
      // }
      if (saveDataArry == null || saveDataArry.length == 0 ) {
        this.clearInputDataTable();
      }
    },
    /**
     * 役員情報入力データクリア
     */
    clearInputDataTable() {
        this.inputDate = "";
        this.desserts = [
          { no: "1", officer: { cd:"", name:"" }, name: "", reason:{ cd:"", name:"" }, address: "" },
          { no: "2", officer: { cd:"", name:"" }, name: "", reason:{ cd:"", name:"" }, address: "" },
          { no: "3", officer: { cd:"", name:"" }, name: "", reason:{ cd:"", name:"" }, address: "" },
          { no: "4", officer: { cd:"", name:"" }, name: "", reason:{ cd:"", name:"" }, address: "" },
          { no: "5", officer: { cd:"", name:"" }, name: "", reason:{ cd:"", name:"" }, address: "" },
          { no: "6", officer: { cd:"", name:"" }, name: "", reason:{ cd:"", name:"" }, address: "" },
          { no: "7", officer: { cd:"", name:"" }, name: "", reason:{ cd:"", name:"" }, address: "" },
          { no: "8", officer: { cd:"", name:"" }, name: "", reason:{ cd:"", name:"" }, address: "" },
          { no: "9", officer: { cd:"", name:"" }, name: "", reason:{ cd:"", name:"" }, address: "" },
          { no: "10", officer: { cd:"", name:"" }, name: "", reason:{ cd:"", name:"" }, address: "" }
          // { no: "1", officer: { cd:"", name:"" }, name: "", reason:{ cd:"", name:"" }, detailInfo: "" },
          // { no: "2", officer: { cd:"", name:"" }, name: "", reason:{ cd:"", name:"" }, detailInfo: "" },
          // { no: "3", officer: { cd:"", name:"" }, name: "", reason:{ cd:"", name:"" }, detailInfo: "" },
          // { no: "4", officer: { cd:"", name:"" }, name: "", reason:{ cd:"", name:"" }, detailInfo: "" },
          // { no: "5", officer: { cd:"", name:"" }, name: "", reason:{ cd:"", name:"" }, detailInfo: "" },
          // { no: "6", officer: { cd:"", name:"" }, name: "", reason:{ cd:"", name:"" }, detailInfo: "" },
          // { no: "7", officer: { cd:"", name:"" }, name: "", reason:{ cd:"", name:"" }, detailInfo: "" },
          // { no: "8", officer: { cd:"", name:"" }, name: "", reason:{ cd:"", name:"" }, detailInfo: "" },
          // { no: "9", officer: { cd:"", name:"" }, name: "", reason:{ cd:"", name:"" }, detailInfo: "" },
          // { no: "10", officer: { cd:"", name:"" }, name: "", reason:{ cd:"", name:"" }, detailInfo: "" }
          // { no: "1", officerNm: "", name: "", nameKana: "", reason:{ cd:"", name:"" }, detailInfo: "" },
          // { no: "2", officerNm: "", name: "", nameKana: "", reason:{ cd:"", name:"" }, detailInfo: "" },
          // { no: "3", officerNm: "", name: "", nameKana: "", reason:{ cd:"", name:"" }, detailInfo: "" },
          // { no: "4", officerNm: "", name: "", nameKana: "", reason:{ cd:"", name:"" }, detailInfo: "" },
          // { no: "5", officerNm: "", name: "", nameKana: "", reason:{ cd:"", name:"" }, detailInfo: "" },
          // { no: "6", officerNm: "", name: "", nameKana: "", reason:{ cd:"", name:"" }, detailInfo: "" },
          // { no: "7", officerNm: "", name: "", nameKana: "", reason:{ cd:"", name:"" }, detailInfo: "" },
          // { no: "8", officerNm: "", name: "", nameKana: "", reason:{ cd:"", name:"" }, detailInfo: "" },
          // { no: "9", officerNm: "", name: "", nameKana: "", reason:{ cd:"", name:"" }, detailInfo: "" },
          // { no: "10", officerNm: "", name: "", nameKana: "", reason:{ cd:"", name:"" }, detailInfo: "" },
          // { no: "1", officerNm: "", name: "", reason:{ cd:"", name:"" }, detailInfo: "" },
          // { no: "2", officerNm: "", name: "", reason:{ cd:"", name:"" }, detailInfo: "" },
          // { no: "3", officerNm: "", name: "", reason:{ cd:"", name:"" }, detailInfo: "" },
          // { no: "4", officerNm: "", name: "", reason:{ cd:"", name:"" }, detailInfo: "" },
          // { no: "5", officerNm: "", name: "", reason:{ cd:"", name:"" }, detailInfo: "" },
          // { no: "6", officerNm: "", name: "", reason:{ cd:"", name:"" }, detailInfo: "" },
          // { no: "7", officerNm: "", name: "", reason:{ cd:"", name:"" }, detailInfo: "" },
          // { no: "8", officerNm: "", name: "", reason:{ cd:"", name:"" }, detailInfo: "" },
          // { no: "9", officerNm: "", name: "", reason:{ cd:"", name:"" }, detailInfo: "" },
          // { no: "10", officerNm: "", name: "", reason:{ cd:"", name:"" }, detailInfo: "" },
        ];
    },
     /*
    * 事由名称取得
    */
    getReasonName(cd) {
      let retVal = "";
      let searchArry = "";
      if (cd != "") {
        searchArry = this.reasons.find((v) => v.cd === cd);
      }
      if (searchArry != null) {
        retVal = searchArry.name;
      }
      return retVal;
    },
    getOfficerName(cd) {
      let retVal = "";
      let searchArry = "";
      if (cd != "") {
        searchArry = this.officers.find((v) => v.cd === cd);
      }
      if (searchArry != null) {
        retVal = searchArry.name;
      }
      return retVal;
    },
    //  /*
    // * 日付フォーマット
    // */
    // frmtDate(date) {
    //   let retVal = "";
    //   if (
    //     date != "" &&
    //     date != null &&
    //     date !== "undefined" &&
    //     date.length == 10
    //   ) {
    //     retVal = new Date(date).toISOString().substr(0, 10);
    //   }
    //   return retVal;
    // },
    /*
    * 役員情報一覧「編集」アイコン押下
    */
    editItem(item) {

      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.detailInfo = Utils.delBrTag(this.editedItem.detailInfo);

      this.disabledOfficers = false;
      // this.requiredDetailInfo = false;
      this.disabledReasons = false;
      // 入力種別毎の画面設定
      if (this.propInputTyp === Constants.INPUT_TYP_APPOINT) {
        // 就任系
        this.reasons = this.$store.getters['master/getChangeOfficerKbnAppointList'];
      } else if (this.propInputTyp === Constants.INPUT_TYP_RESIGN) {
        // 退任系
        this.reasons = this.$store.getters['master/getChangeOfficerKbnResignList'];
      } else if (this.propInputTyp === Constants.INPUT_TYP_ADDRESS) {
        // 住所変更
        this.reasons = this.$store.getters['master/getChangeOfficerKbnOthersList'];
        this.editedItem.reason = {cd: Constants.CHANGE_OFFICER_KBN_OTHERS, name: this.getReasonName(Constants.CHANGE_OFFICER_KBN_OTHERS)};
        this.editedItem.officer = {cd: Constants.OFFICER_KBN_DAIHYO, name: this.getOfficerName(Constants.OFFICER_KBN_DAIHYO)};
        this.disabledOfficers = true;
        // this.requiredDetailInfo = true;
        this.disabledReasons = true;
        // this.changeReason(this.editedItem.reason.cd)
      }
      this.inputDialog = true;
    },
    /*
    * 役員情報一覧「削除」アイコン押下
    */
    deleteItem(item) {
      this.deletedItem = item;
      this.dlgMsgConfirm.isOpen = true;
    },
    /**
     * 役員情報一覧「クリア」押下
     */
    clear() {
      this.dlgMsgConfirmAllDel.isOpen = true;
    },
    /*
    * 役員情報一覧「確定」押下
    */
    save() {
      // 入力チェック
      let chkRslt = this.unitCheckForSave();
      if (!chkRslt) {
        return;
      }
      // 入力内容をデータストアへ登録
      // this.$store.dispatch('requestRegInfo/setOfficerList', this.desserts);
      if (this.propInputTyp === Constants.INPUT_TYP_APPOINT) {
        // 就任系
        this.$store.dispatch('requestRegInfo/setOfficerAppointList', this.desserts);
        this.$store.dispatch('requestRegInfo/setAppointDate', this.inputDate);
      } else if (this.propInputTyp === Constants.INPUT_TYP_RESIGN) {
        // 退任系
        this.$store.dispatch('requestRegInfo/setOfficerResignList', this.desserts);
        this.$store.dispatch('requestRegInfo/setResignDate', this.inputDate);
      } else if (this.propInputTyp === Constants.INPUT_TYP_ADDRESS) {
        // 住所変更
        this.$store.dispatch('requestRegInfo/setOfficerOthersList', this.desserts);
        this.$store.dispatch('requestRegInfo/setOthersDate', this.inputDate);
      }
      //let saveDataArry = this.$store.getters['requestRegInfo/getOfficerList'];
      // console.log(saveDataArry);
      // 役員情報入力画面閉じる
      this.doYes();
      this.officerDialog = false;
      this.defaultDesserts = JSON.parse(JSON.stringify(this.desserts));
    },
    unitCheckForSave: function() {
      let retVal = true;
      let errMsg = "";
      
      // 役員変更入力有無
      let inputOfficerInfo = false;
      let dessert = null;
      for (dessert of this.desserts) {
        if (dessert.officer.cd != "" && dessert.name != "" && dessert.reason.cd != "" && dessert.address != "") {
        //  if (dessert.officer.cd != "" && dessert.name != "" && dessert.reason.cd != "" && dessert.detailInfo != "") {
          // 入力あり
          inputOfficerInfo = true;
          break;
        }
      }
      // 日付および役員変更入力なし（正常）
      if (this.inputDate == null || this.inputDate == "") {
        if (this.desserts == null || this.desserts.length == 0) {
          return retVal;
        } else {
          if (!inputOfficerInfo) {
            return retVal;
          }
        }
      }
      if (this.inputDate == null || this.inputDate == "") {
        if (this.propInputTyp === Constants.INPUT_TYP_APPOINT) {
          errMsg = this.$i18n.t('msg.err.cm020', ['株主総会・取締役会の開催日付']);
        } else if (this.propInputTyp === Constants.INPUT_TYP_RESIGN) {
          errMsg = this.$i18n.t('msg.err.cm020', ['退任等の日付']);
        } else if (this.propInputTyp === Constants.INPUT_TYP_ADDRESS) {
          errMsg = this.$i18n.t('msg.err.cm020', ['住所移転日付']);
        }
      } else if (!inputOfficerInfo) {
        errMsg = this.$i18n.t('msg.err.cm020', ['役員変更の詳細']);
      }
      if (errMsg != "") {
        retVal = false;
        this.dlgMsgInputErr.msg = errMsg;
        this.dlgMsgInputErr.isOpen = true;
      }
      return retVal;
    },
   /*
    * 役員情報一覧「キャンセル」押下
    */
    cancel() {
      // 役員情報入力画面閉じる
      this.doNo();
      this.officerDialog = false;
      this.desserts = JSON.parse(JSON.stringify(this.defaultDesserts));
    },
    /**
     * 役員変更リスト選択 
     */
    changeReason(cd) {
      if (cd == null || cd == "") {
        return;
      }
     /* -- 役員情報 -- */
      let changeOfficerDetailList = this.$store.getters["master/getChangeOfficerDetailList"];

      let searchArry = "";
      if (cd != "") {
        searchArry = changeOfficerDetailList.find((v) => v.cd === cd);
        this.editedItem.detailInfo = searchArry.name;
      }
    },
    // /**
    //  * 資格リスト選択 
    //  */
    // changeOfficer: function(cd) {
    //   this.requiredDetailInfo = false;
    //   if (this.propInputTyp !== Constants.INPUT_TYP_RESIGN) {
    //     return;
    //   }
    //   if (cd !== Constants.OFFICER_KBN_DAIHYO) {
    //     return;
    //   }
    //   this.requiredDetailInfo = true;
    // },
    /*
    * 入力ダイアログ「キャンセル」押下
    */
    closeDialog() {
      this.inputDialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    /*
    * 入力ダイアログ「確定」押下
    */
    saveDialog() {
      if (!this.unitCheckForInput()) {
        return;
      }
      // if (!this.correlationCheckForInput()) {
      //   return;
      // }
      this.inputDialog = false;
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
        if (this.desserts == null) {
          return;
        }
        this.desserts.forEach((dessert, index) => {
          this.desserts[index].detailInfo = Utils.nl2br(dessert.detailInfo);
        });
      } else {
        this.desserts.push(this.editedItem);
      }
    },
    unitCheckForInput: function() {
      let retVal = true;
      let errList = new Array();
      if (this.editedItem.officer.cd == "") {
        errList.push(this.$i18n.t('msg.err.cm020', ['資格(役員役職)']));
      }
      // if (this.editedItem.officerNm.trim() == "") {
      //   errList.push(this.$i18n.t('msg.err.cm020', ['資格(役員役職)']));
      // }
      if (this.editedItem.name.trim() == "") {
        errList.push(this.$i18n.t('msg.err.cm020', ['氏名']));
      }
      // if (this.editedItem.nameKana == "") {
      //   errList.push(this.$i18n.t('msg.err.cm020', ['氏名(フリガナ)']));
      // }
      if (this.editedItem.reason.cd == "") {
        errList.push(this.$i18n.t('msg.err.cm020', ['変更の事由']));
      }
      if (this.editedItem.address.trim() == "") {
        errList.push(this.$i18n.t('msg.err.cm020', ['役員住所']));
      }
      // if (this.editedItem.detailInfo.trim() == "") {
      //   errList.push(this.$i18n.t('msg.err.cm020', ['変更詳細']));
      // }
      // if (this.requiredDetailInfo) {
      //   if (this.editedItem.detailInfo.trim() == "") {
      //     errList.push(this.$i18n.t('msg.err.cm020', ['変更詳細']));
      //   }
      // }
      if (errList.length > 0) {
        retVal = false;
        this.dlgMsgInputErr.msg = Utils.createMsgViewString(errList);
        this.dlgMsgInputErr.isOpen = true;
      }
      return retVal;
    },
    correlationCheckForInput: function() {
      let retVal = true;
      let errList = new Array();
      let inputVal = this.editedItem.detailInfo.replace(/\r?\n/g, "");
      let defVal = null;
      let changeOfficerDetailList = this.$store.getters["master/getChangeOfficerDetailList"];
      let cd = this.editedItem.reason['cd'];
      let searchArry = "";
      // if (!this.requiredDetailInfo) {
      //   return retVal;
      // }
      if (cd != "" && cd != null) {
        searchArry = changeOfficerDetailList.find((v) => v.cd === cd);
        defVal = searchArry.name.replace(/\r?\n/g, "");
      }
      if (inputVal == defVal ) {
        errList.push(this.$i18n.t('msg.err.cm020', ['変更詳細']));
      }
      if (errList.length > 0) {
        retVal = false;
        this.dlgMsgInputErr.msg = Utils.createMsgViewString(errList);
        this.dlgMsgInputErr.isOpen = true;
      }
      return retVal;
    },
  },
};
</script>

<style scoped>
.main-dialog {
  max-width: 94%;
}
.table1 {
  width: 70%;
  height: 70%;
  margin: 0 0 0 auto;
}
.red-moji {
  color: red;
  text-align: right;
}

@media screen and (max-width: 750px) {

}
</style>
